import { render, staticRenderFns } from "./OfflinePurchase.vue?vue&type=template&id=3c19b1b4&scoped=true"
import script from "./OfflinePurchase.vue?vue&type=script&lang=ts"
export * from "./OfflinePurchase.vue?vue&type=script&lang=ts"
import style0 from "./OfflinePurchase.vue?vue&type=style&index=0&id=3c19b1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19b1b4",
  null
  
)

export default component.exports